import { Box, Container, Divider, Link, Stack, Typography } from "@mui/material";
import React from "react";
import FunnelStepper from "./FunnelStepper.tsx";
import { createLogger } from "../../lib/logger.ts";

const logger = createLogger("FunnelLayout");
// import FunnelStepperMUI from "./FunnelStepperMUI.tsx";

type FunnelLayoutProps = {
    funnelSteps: FunnelStep[],
    currentFunnelStep: FunnelStep,
    currentStep: number,
    onStepperClick: (stepIndex: number) => void,
};

const FunnelLayout: React.FC<FunnelLayoutProps> = ({
    funnelSteps,
    currentFunnelStep,
    currentStep,
    onStepperClick
}) => {
    logger.debug('Loading FunnelLayout');
    return (
        <Container maxWidth={false} sx={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            backgroundImage: 'url("https://cdn.shopify.com/s/files/1/0779/5569/4806/files/Adrex_Haus.jpg?v=1764073124");',
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundColor: "#F5F5F5",
            minHeight: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
        }}>
            <Box sx={{
                width: { xs: "100vw", md: "calc(2/3 * 100vw)" },
                maxWidth: "1200px",
                textAlign: "center",
                alignItems: "center",
                justifyItems: "center",
                boxSizing: "border-box",
            }}>
                <Box sx={{
                    width: "100%",
                    backgroundColor: "rgba(255,255,255,0.2)",
                    backdropFilter: "blur(20px)",
                    // border: "1px solid rgba(255, 255, 255, 0.2)",
                    borderRadius: "1rem",
                    p: 0.75
                }}>
                    <Box sx={{
                        gap: 1.5,
                        backgroundColor: "rgba(255,255,255,0.2)",
                        backdropFilter: "blur(50px)",
                        border: "1px solid rgba(255, 255, 255, 0.2)",
                        borderRadius: "1rem",
                        p: { xs: 3, md: 5 },
                        maxWidth: "100%",
                        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        boxSizing: "border-box",
                    }}>
                        {(currentStep > 0) &&
                            <FunnelStepper
                                funnelSteps={funnelSteps}
                                currentStepIndex={currentStep}
                                onClick={onStepperClick}
                            />
                            // <FunnelStepperMUI
                            //     funnelSteps={funnelSteps}
                            //     currentStepIndex={currentStep}
                            //     onClick={onStepperClick}
                            // />
                        }
                        <currentFunnelStep.component/>
                    </Box>
                </Box>
            </Box>
            <Box sx={{
                position: "absolute",
                bottom: 16,
                right: 16,
            }}>
                <Stack
                    direction="row"
                    sx={{ justifyContent: "right" }}
                    spacing={2}
                    divider={<Divider orientation="vertical" sx={{ borderColor: "grey.50" }} flexItem/>}
                >
                    <Link
                        href={import.meta.env.VITE_SHOPIFY_STOREFRONT_DOMAIN + '/pages/widerruf-formular'}
                        target={"_blank"}
                        underline={"none"}
                    >
                        <Typography color={"background.default"}>Widerruf</Typography>
                    </Link>
                    <Link href="https://adrex.de/datenschutz/" target={"_blank"} underline={"none"}>
                        <Typography color={"background.default"}>Datenschutz</Typography>
                    </Link>
                    <Link
                        href="https://adrex.de/agb-online-shop/"
                        target={"_blank"}
                        underline={"none"}
                    >
                        <Typography color={"background.default"}>AGB</Typography>
                    </Link>
                    <Link
                        href="https://adrex.de/barrierefreiheit-online-shop/"
                        target={"_blank"}
                        underline={"none"}
                    >
                        <Typography color={"background.default"}>Barrierefreiheit</Typography>
                    </Link>
                    <Link href="https://adrex.de/impressum-online-shop/" target={"_blank"} underline={"none"}>
                        <Typography color={"background.default"}>Impressum</Typography>
                    </Link>
                </Stack>
            </Box>
        </Container>
    );
};

export default FunnelLayout;